export const copyTextToClipboard = async text => {
	if (!navigator.clipboard) {
		fallbackCopyTextToClipboard(text);
	} else {
		navigator.clipboard.writeText(text);
	}
};

const fallbackCopyTextToClipboard = text => {
	var textArea = document.createElement('textarea');
	textArea.value = text;
	textArea.style.position = 'fixed'; //avoid scrolling to bottom
	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();
	document.execCommand('copy');
	document.body.removeChild(textArea);
};
